// write home page here
const Share = () => {
    return (
        <div>
        <h1>Home Page</h1>
        </div>
    );
}
export default Share;